export type MynazcaDocId = 'usage' | 'route-tips' | 'contribute';

export type MynazcaDocLang = 'ja' | 'en';

export type MynazcaDocContent = {
  title: string;
  body: string;
};

const DOC_FILENAMES: Record<MynazcaDocId, string> = {
  usage: 'usage',
  'route-tips': 'route-tips',
  contribute: 'contribute',
};

const FALLBACK_TITLES: Record<MynazcaDocId, Record<MynazcaDocLang, string>> = {
  usage: { ja: '使い方', en: 'How to use' },
  'route-tips': { ja: 'ルート作成のコツ', en: 'Route creation tips' },
  contribute: { ja: '開発協力のお願い', en: 'Help us improve MyNazca' },
};

export function isMynazcaDocId(value: string): value is MynazcaDocId {
  return value === 'usage' || value === 'route-tips' || value === 'contribute';
}

/** 先頭の `# タイトル` をページ見出しに使い、本文からは除く */
export function parseMynazcaDocMarkdown(raw: string, fallbackTitle: string): MynazcaDocContent {
  const trimmed = raw.trim();
  const match = /^#\s+(.+?)\s*(?:\r?\n|$)/.exec(trimmed);
  if (!match) {
    return { title: fallbackTitle, body: trimmed };
  }
  return {
    title: match[1].trim(),
    body: trimmed.slice(match[0].length).trim(),
  };
}

export async function loadMynazcaDoc(
  docId: MynazcaDocId,
  lang: MynazcaDocLang,
): Promise<MynazcaDocContent> {
  const base = DOC_FILENAMES[docId];
  const url = `/mynazca/docs/${base}-${lang}.md`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to load document: ${url}`);
  }
  const raw = await response.text();
  return parseMynazcaDocMarkdown(raw, FALLBACK_TITLES[docId][lang]);
}
